import { render, staticRenderFns } from "./CompanyOrderList.vue?vue&type=template&id=826f2070&scoped=true&"
import script from "./CompanyOrderList.vue?vue&type=script&lang=js&"
export * from "./CompanyOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f2070",
  null
  
)

export default component.exports